import React from "react";
import PropTypes from "prop-types";
import { DownloadLink, usePathFactory } from "@sia/style-guide";

/**
 * Component that renders a link to the contact us page.
 *
 * @param {Object} props - The props that define the component.
 * @param {function} props.translate - Function to translate text.
 * @param {string} props.translationKeyPrefix - The prefix for the translation key.
 *
 * @returns {JSX.Element} The LinkToContactUs component.
 */
const contact_form = process.env.REACT_APP_BENCHMARKING_CONTACT_FORM;
const LinkToContactUs = ({ translate, translationKeyPrefix }) => {
  const pathFactory = usePathFactory();

  return (
    <>
      <p className="sia-text-10">{translate(`${translationKeyPrefix}.contact-us`)}</p>
      {/* @ts-ignore */}
      <DownloadLink
        openInCurrentTab
        variant="INTERNAL"
        href={pathFactory.create(contact_form)}
        text={translate("benchmarking.contact-us.text")}
      ></DownloadLink>
    </>
  );
};

LinkToContactUs.propTypes = {
  translate: PropTypes.func.isRequired,
  translationKeyPrefix: PropTypes.string,
};

export default LinkToContactUs;
